var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 26,
    viewBox: "0 0 50 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 26,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2482_9346",
    transform: "matrix(0.01 0 0 0.0192308 0 -0.461538)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2482_9346",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB10lEQVR4nO3bT0rDQBiG8RzAVbX5pNWleBYP4SEqzGy9gpcQtCjikZx0I/6h1a2gfBEq1LaWljRvzPODgCiDdp50mo5plgEAAAAAAAAAAAAAAAAAAACQUYS9oxTsNkV7K6J9ctjW5sDnPIX8Og06/WmMIuYvRLBaT8QU86cyij8ziGEiq0J+lbFMmc4RbJzNfrPu17O2+TX/BKkXQcQQRAxBxBBEDEHEEKQtQXw/hvczIkGK0D1N0T4IUmOQx/PuThH3T4po9/O2Adb421pp4yAp2kUK9v7Xvsx2Hk7zbRykCHa5ykbZdh5O8xGkLVdZPEPWQxAxBBFDEDEEEUMQMVJBRme9wxTtprw36fuesLtR6B2v+js3Ha9AJohP5tz7wUL+6j+rerwKmSB+Zi96l59iPqx6vAqlIMtuW51UPV5FM4IEG1c9XoVMEH8BXrjkhPy66vEqZIL41ZC/AM+ZzOci9g+qHq9CJsjPZWs+9DXfj1T+G3j1ydx0/L8OgvUQRAxBxBBEDEHEEEQMQcQQpAFBJks26TjiFufA9+Bmb5LmsJo/Fj3o9P1D64SwWk9Gb/AQdnvlOuZfeB2WL6sjxsTnfhoDAAAAAAAAAAAAAAAAAAAAQKbgC/BhScm5n4xkAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVin);
export default __webpack_public_path__ + "static/media/vin.922c8e3c92a38952876746920a7d5713.svg";
export { ForwardRef as ReactComponent };